module.exports = __webpack_public_path__ + "static/media/1.a4713c10.jpg";